import Vue from 'vue'
import App from './App.vue'
import Config from './config'
import vuetify from '@/plugins/vuetify'
import store from '@/store/index'
import router from '@/router/index'
//import AsyncComputed from 'vue-async-computed'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCurrencyFilter from 'vue-currency-filter'
//import Truncate from 'lodash.truncate'
import Moment    from 'moment'
import NProgress from 'nprogress'
import colors    from 'vuetify/es5/util/colors';
import * as VueGoogleMaps from 'vue2-google-maps'
//import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueGeolocation from 'vue-browser-geolocation';
import '@/registerServiceWorker'

import 'sweetalert2/dist/sweetalert2.min.css'
//import '@mdi/font/css/materialdesignicons.css'
//import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'nprogress/nprogress.css'

Vue.config.productionTip = false
//Vue.filter('truncate', Truncate);
Vue.config.productionTip = false;
Vue.use(VueSweetalert2);
//Vue.use(AsyncComputed);
Vue.use(VueGeolocation);
Vue.use(VueCurrencyFilter, {
  symbol : '', thousandsSeparator: '.', fractionCount: 0, fractionSeparator: ',', symbolPosition: 'front', symbolSpacing: false
});

Vue.prototype.$_      = require('lodash');
Vue.prototype.$config = Config;
Vue.prototype.$moment = Moment;
Vue.prototype.$color  = function(){
  var color = this.$_.sample(colors);     
  return color.base === undefined ? 'info':color.base;
}

String.prototype.capitalize  = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyADfuu8uTu92idN50Bf4hifkZ0Ka_qsphs',
    //key: 'AIzaSyDR_pUl6SqElZpjWCNHDxCLSormeVkNwC0',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // v: '3.26',
  },
})
/*
Vue.component(VueQrcode.name, VueQrcode);
*/

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

/* eslint-disable no-new */
new Vue({
  vuetify,
  el: '#app',
  router,
  store,
  render: h => h(App),
})